<div class="modal-content">
  <div class="modal-header">
      <h4 class="modal-title">Detalle de producto</h4>
      <button type="button" class="close" (click)="cancel()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <product-info [product] = "product" ></product-info>
    </div>
</div>

